<app-modal title="MEETING_POINTS.NEW_MEETING_POINT"
          [loading]="loading"
          (submitClicked)="submit()"
          [closeText]="'CANCEL'"
          [submitText]="'SAVE'"
          >
  <app-address-form (formGroupOutput)="formGroup = $event"
                    [type]="'meeting_point'"
                    [showNameField]="false"
                    [showActiveStatus]="true"/>
</app-modal>

